import React from 'react';
import {
  withErrorBoundary,
  AIActivator,
  AI_AGENTS_MAP,
  getTranslatedText,
  useUserMSPCheckHook,
  useIsAuthorisedHook
} from '@nile/components';
import { Card, TextStyle } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import AIFeaturesHook from '@nile/components/src/Utils/aiFeaturesHook';
import { useIntl, FormattedMessage } from 'react-intl';
import { isEmpty } from 'lodash';

const TicketInsightTriageCard = ({ ticket, listenDefaultAgent = false }) => {
  const intl = useIntl();

  const isMSP = useUserMSPCheckHook();

  const isAIFeatureAuthorised = useIsAuthorisedHook('aiFeature.allow');
  const aiFeaturesHook = AIFeaturesHook();
  const triageData = aiFeaturesHook?.getAIFeatureData(
    AI_AGENTS_MAP.TICKET_TRIAGE
  );

  const isAgentActive = triageData?.state === 'ACTIVE';

  const isTriageAgent = ticket?.technician?.userId === '14';

  const status = ticket?.aiAgentActionData?.status;

  const inProgress = status === 'IN_PROGRESS';
  const waitingOnUser = status === 'WAITING_FOR_REQ_ACTION';
  const waitingForTechAction = status === 'WAITING_FOR_TECH_ACTION';

  const getDescription = () => {
    if (inProgress) {
      return 'ticket.insights.triage.agent.description.inProgress';
    }
    if (waitingOnUser) {
      return 'ticket.insights.triage.agent.description.waitingOnUser';
    }

    return 'ticket.insights.triage.agent.description.working';
  };

  const description = getDescription();

  if (!isAgentActive || !isTriageAgent || !isMSP || !isAIFeatureAuthorised) {
    return null;
  }

  return (
    <Card gradientVariant="infoLeft" padding="sizeSmall">
      <div className="flex g10 actr mb10">
        <div className="flex actr">
          <SVGIcon name="TriageAgent" />
        </div>
        <div>
          <TextStyle weight="SemiBold">
            <FormattedMessage id="common.triage.agent" />
          </TextStyle>
        </div>
      </div>

      {isEmpty(ticket?.aiAgentActionData) ? (
        <div className="flex g10 actr col">
          <div>
            <SVGIcon name="SuccessRound" size="xl" />
          </div>
          <div>
            <TextStyle>
              <FormattedMessage id="ai.ticket.fields.mapping.success.message" />
            </TextStyle>
          </div>
        </div>
      ) : (
        <div className="ml-30">
          <TextStyle>
            <FormattedMessage id={description} />
          </TextStyle>

          {waitingForTechAction && (
            <div className="mt20">
              <AIActivator
                featureName={AI_AGENTS_MAP.TICKET_TRIAGE}
                icon="EyeVisible"
                buttonText={getTranslatedText(
                  intl,
                  'ticket.insights.triage.agent.buttonText'
                )}
                buttonVariant="aiPrimaryFill"
                buttonSize="slim"
                customProps={{
                  variables: {
                    id: ticket?.ticketId
                  }
                }}
                listenDefaultAgent={listenDefaultAgent}
              />
            </div>
          )}
        </div>
      )}
    </Card>
  );
};

export default withErrorBoundary(TicketInsightTriageCard);
